import { z } from 'zod';
import { identifierSchema } from './common.js';
/**
 * Lesson and transcript shapes — the licensed-content endpoints.
 *
 * Everything in this file is served only to an authenticated session (00-context §10.1). The
 * schemas are separate from `course.ts` for exactly that reason: a course response must never be
 * able to grow a transcript field by accident.
 */
export const transcriptCueSchema = z.object({
    id: z.string(),
    position: z.number().int(),
    /** Milliseconds into the lesson. The deep-link target for "jump to 04:32". */
    startMs: z.number().int(),
    endMs: z.number().int(),
    text: z.string(),
});
export const lessonSegmentSchema = z.object({
    id: z.string(),
    segmentNo: z.number().int(),
    fileName: z.string(),
    title: z.string().nullable(),
    summary: z.string().nullable(),
    keyTopics: z.array(z.string()),
    durationMs: z.number().int(),
    wordCount: z.number().int(),
    /**
     * False for the `.txt` fallback transcripts, which carry no timecodes. Their text is still
     * searchable, but the UI must not offer a timestamp it does not have.
     */
    hasTimings: z.boolean(),
    text: z.string(),
});
export const lessonDetailSchema = z.object({
    id: z.string(),
    lessonNo: z.number().int(),
    title: z.string().nullable(),
    summary: z.string().nullable(),
    keyTopics: z.array(z.string()),
    durationSeconds: z.number().int(),
    wordCount: z.number().int(),
    isIntro: z.boolean(),
    position: z.number().int(),
    module: z.object({
        id: z.string(),
        moduleNo: z.number().int(),
        title: z.string().nullable(),
        summary: z.string().nullable(),
    }),
    course: z.object({
        id: z.string(),
        isbn: z.string(),
        slug: z.string(),
        title: z.string(),
    }),
    segments: z.array(lessonSegmentSchema),
});
export const lessonIdParamSchema = z.object({ id: identifierSchema });
export const transcriptQuerySchema = z.object({
    format: z.enum(['text', 'cues']).default('text'),
});
export const transcriptResponseSchema = z.object({
    lessonId: z.string(),
    format: z.enum(['text', 'cues']),
    hasTimings: z.boolean(),
    durationMs: z.number().int(),
    wordCount: z.number().int(),
    /** Present when `format=text`. */
    text: z.string().optional(),
    /** Present when `format=cues`. */
    cues: z.array(transcriptCueSchema).optional(),
});
//# sourceMappingURL=lesson.js.map